import React, {} from 'react'
import PropTypes from 'prop-types'


import { 
    useForm, 
    // Controller
} from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup"

// Atoms
import TextField from "Components/Atoms/TextField"

function MSolicitarSalesPart(props){
    const {
        onSubmit,
        onClose,
    } = props

    const schemaFilter = yup.object().shape({
        client: yup.string().required(),
        name: yup.string().required(),
        rut: yup.string().required(),
        email: yup.string().email('Formato del correo invalido').required('Es requerido'),
        phoneContact: yup.number(),
    });

    const { 
        register, 
        handleSubmit,
        // watch, 
        errors, 
        // getValues,  
        // control,
        // setValue,
        //formState, 
        // unregister 
    } = useForm({
        defaultValues: {
            // minPrice: '',
            // typePlay: [],
            client: -1,
            name: "",
            rut: "",
            email: "",
            phoneContact: "",
        },
        resolver: yupResolver(schemaFilter),
    });

    return(
        <div className='modalClaro mSolicitarSales'>
            <div className="mSolicitarSalesCont">
                <form className="mSolSales" onSubmit={handleSubmit(onSubmit)}>
                    <p className="mSolSalTitle">Chat de Ventas</p>
                    <p className="mSolSalDesc">Cuentanos de ti para poder chatear con un Ejecutivo:</p>
                    <fieldset> 
                       
                        <label>¿Eres Cliente de Claro Chile?</label>
                        <span className="select">
                            <select {...register('client')}  defaultValue='-1'>
                                <option value="-1" disabled>Seleccione una opción</option>
                                {[
                                    {value: 'no', label: 'No soy Cliente de Claro Chile'}, 
                                    {value: 'si', label: 'Si soy Cliente de Claro Chile'},
                                ].map(item => (
                                    <option key={item.value} value={item.value}>
                                        {item.label}
                                    </option>
                                ))}
                                
                            </select>
                        </span>
                    </fieldset>
                    <div className="mSolSalesCol2">
                        <fieldset> 
                            <TextField
                                placeholder='Ingresa tu nombre completo'
                                className=''
                                // className='inputField'
                                register={register("name")} 
                            >
                                Nombre y Apellido
                            </TextField>
                            {errors?.name?.message &&
                                <div className="notification error">
                                    <p>
                                        {errors?.name?.message}
                                    </p>
                                </div>
                            }
                        </fieldset>
                        <fieldset> 
                            <TextField
                                placeholder='Ingresa tu RUT'
                                className=''
                                // className='inputField'
                                register={register("rut")} 
                            >
                                RUT
                            </TextField>
                            {errors?.rut?.message &&
                                <div className="notification error">
                                    <p>
                                        {errors?.rut?.message}
                                    </p>
                                </div>
                            }
                        </fieldset>
                    </div>
                    <div className="mSolSalesCol2">
                        <fieldset> 
                            <TextField
                                placeholder='Ingresa tu correo'
                                className=''
                                // className='inputField'
                                register={register("email")} 
                            >
                                Correo Electronico
                            </TextField>
                            {errors?.email?.message &&
                                <div className="notification error">
                                    <p>
                                        {errors?.email?.message}
                                    </p>
                                </div>
                            }
                        </fieldset>
                        <fieldset> 
                            <TextField
                                placeholder='Ingresa tu teléfono'
                                type='number'
                                className=''
                                // className='inputField'
                                register={register("phoneContact")} 
                            >
                                Teléfono de Contacto
                            </TextField>
                            {errors?.phoneContact?.message &&
                                <div className="notification error">
                                    <p>
                                        {errors?.phoneContact?.message}
                                    </p>
                                </div>
                            }
                        </fieldset>
                    </div>
                    <div className="mSolSalesActions">
                        <button className="btn btnPrimario" type='submit'>Enviar</button>
                        <a className="textLink" id="mSolSelesOptionsBtn" href="#!" onClick={onClose}>Ver otras opciones</a>
                        {/* <a className="textLink" id="mSolSelesOptionsBtn" href="javascript:;">Ver otras opciones</a> */}
                    </div>
                </form>
            </div>
        </div>
    )
}

MSolicitarSalesPart.defaultProps = {
    onSubmit: (data)=>{}
}

MSolicitarSalesPart.propTypes = {
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
}

export default MSolicitarSalesPart